module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if(control.type == 'hidden') { 
    ; __append("\n<control ")
    ; __append( Html.attributes(control) )
    ; __append(" />\n")
    ;  } else { 
    ; __append("\n")
    ;  if(control.type == 'checkbox') { 
    ; __append("\n<div class=\"padded\">\n    ")
    ;  } else { 
    ; __append("\n    <div data-ctrl-target=\"")
    ; __append(escapeFn( control.target ))
    ; __append("\">\n        ")
    ;  } 
    ; __append("\n        ")
    ;  if(control.type != 'checkbox') { 
    ; __append("\n\n            ")
    ; if(control.type != "datetimepicker" && control.type != "datepicker") {
    ; __append("\n                <label class=\"empty-control-label\">\n                    <input data-filter-id=\"")
    ; __append(escapeFn( control.bind ? control.bind : control.target ))
    ; __append("\" data-target=\"")
    ; __append(escapeFn( control.target ))
    ; __append("\" name=\"empty-control\" type=\"checkbox\"/>\n                    не указан\n                </label>\n            ")
    ;  } 
    ; __append("\n        ")
    ;  } else { 
    ; __append("\n\n        <label class=\"title\">\n            ")
    ;  } 
    ; __append("\n            <div name=\"filter-cell-control\"><control ")
    ; __append( Html.attributes(control) )
    ; __append(" /></div>\n            ")
    ;  if(control.type == 'checkbox') { 
    ; __append("\n            <div class=\"title\" name=\"filter-cell-title\">")
    ; __append(escapeFn( control.title ))
    ; __append("</div>\n        </label>\n        ")
    ;  } 
    ; __append("\n    </div>\n")
    ;  } 
  }
  return __output.join("");

}